// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tips-info {\r\n  line-height: 18px;\r\n  color: #c0c4cc;\r\n  font-size: 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;
